// import React, { useState } from 'react';
// import { FaSearch } from 'react-icons/fa';
// import { Link } from 'react-router-dom';

// const NavBar = () => {
//   const [active, setActive] = useState(false);
//   const [searchShow, setSearchShow] = useState(false);
//   const menuActive = () => {
//     setActive(!active);
//   };
//   const searchActive = () => {
//     setSearchShow(!searchShow);
//   };

//   // Control sidebar navigation
//   let items = document.querySelectorAll('.menu-item-has-children > a');
//   for (let i in items) {
//     if (items.hasOwnProperty(i)) {
//       items[i].onclick = function () {
//         this.parentElement
//           .querySelector('.sub-menu')
//           .classList.toggle('active');
//         this.classList.toggle('open');
//       };
//     }
//   }

//   return (
//     <>
//       {/* search popup start*/}
//       <div
//         className={searchShow ? 'td-search-popup active' : 'td-search-popup '}
//         id="td-search-popup"
//       >
//         <form action="/" className="search-form">
//           <div className="form-group">
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Search....."
//             />
//           </div>
//           <button type="submit" className="submit-btn">
//             <FaSearch />
//           </button>
//         </form>
//       </div>
//       {/* search popup end*/}
//       <div
//         onClick={searchActive}
//         className={searchShow ? 'body-overlay active' : 'body-overlay'}
//         id="body-overlay"
//       ></div>
//       {/* navbar start */}
//       <nav className="navbar navbar-area navbar-area_1 navbar-expand-lg">
//         <div className="container nav-container navbar-bg">
//           <div className="responsive-mobile-menu">
//             <button
//               onClick={menuActive}
//               className={
//                 active
//                   ? 'menu toggle-btn d-block d-lg-none open'
//                   : 'menu toggle-btn d-block d-lg-none'
//               }
//               data-target="#itech_main_menu"
//               aria-expanded="false"
//               aria-label="Toggle navigation"
//             >
//               <span className="icon-left" />
//               <span className="icon-right" />
//             </button>
//           </div>
//           <div className="logo">
//             <Link to="/">
//               <img src="assets/img/kklogo.png" alt="img" />
//             </Link>
//           </div>
//           <div className="nav-right-part nav-right-part-mobile">
//             <span className="search-bar-btn" onClick={searchActive}>
//               <FaSearch />
//             </span>
//           </div>
//           <div
//             className={
//               active
//                 ? 'collapse navbar-collapse sopen'
//                 : 'collapse navbar-collapse'
//             }
//             id="itech_main_menu"
//           >
//             <ul className="navbar-nav menu-open text-lg-end">
//               <li className="menu-item-has-children">
//                 <Link to="/">Home</Link>
//               </li>
//               <li className="menu-item-has-children">
//                 <Link to="/service">Service</Link>
//               </li>
//               <li className="menu-item-has-children">
//                 <Link to="/about">About Us</Link>
//               </li>
//               {/* <li className="menu-item-has-children">
//                 <Link to="/blog">Blog</Link>
                
//               </li> */}
//               <li className="menu-item-has-children">
//                 <Link to="/careers">Careers</Link>
//               </li>
//               <li>
//                 <Link to="/contact">Contact Us</Link>
//               </li>
//             </ul>
//           </div>
//           <div className="nav-right-part nav-right-part-desktop align-self-center">
//             <a className="navbar-phone" href="tel:">
//               <span className="icon">
//                 <img src="assets/img/icon/1.png" alt="img" />
//               </span>
//               <span>Need help?</span>
//               <h5>(808) 555-0111</h5>
//             </a>
//           </div>
//         </div>
//       </nav>
//       {/* navbar end */}
//     </>
//   );
// };

// export default NavBar;


import React, { useState, useEffect } from 'react';
import { FaSearch } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const NavBar = () => {
  const [active, setActive] = useState(false);
  const [searchShow, setSearchShow] = useState(false);

  const menuActive = () => {
    setActive(!active);
  };
  const searchActive = () => {
    setSearchShow(!searchShow);
  };

  // ✅ Attach listeners safely after DOM is loaded
  useEffect(() => {
    const items = document.querySelectorAll('.menu-item-has-children > a');
    items.forEach((item) => {
      item.onclick = function (e) {
        const submenu = this.parentElement.querySelector('.sub-menu');
        if (submenu) submenu.classList.toggle('active');
        this.classList.toggle('open');
      };
    });
    // ✅ Optional cleanup
    return () => {
      items.forEach((item) => (item.onclick = null));
    };
  }, []);

  return (
    <>
      {/* search popup start */}
      <div className={searchShow ? 'td-search-popup active' : 'td-search-popup'} id="td-search-popup">
        <form action="/" className="search-form">
          <div className="form-group">
            <input type="text" className="form-control" placeholder="Search....." />
          </div>
          <button type="submit" className="submit-btn">
            <FaSearch />
          </button>
        </form>
      </div>

      <div onClick={searchActive} className={searchShow ? 'body-overlay active' : 'body-overlay'} id="body-overlay"></div>

      {/* navbar start */}
      <nav className="navbar navbar-area navbar-area_1 navbar-expand-lg">
        <div className="container nav-container navbar-bg">
          <div className="responsive-mobile-menu">
            <button
              onClick={menuActive}
              className={
                active ? 'menu toggle-btn d-block d-lg-none open' : 'menu toggle-btn d-block d-lg-none'
              }
              data-target="#itech_main_menu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-left" />
              <span className="icon-right" />
            </button>
          </div>
          <div className="logo">
            <Link to="/">
              <img src="/assets/img/KKglobalLogo.png" alt="img"
              style={{ height: "100px", width: "auto" }}
               />
            </Link>
          </div>
          <div className="nav-right-part nav-right-part-mobile">
            <span className="search-bar-btn" onClick={searchActive}>
              <FaSearch />
            </span>
          </div>
          <div className={active ? 'collapse navbar-collapse sopen' : 'collapse navbar-collapse'} id="itech_main_menu">
            <ul className="navbar-nav menu-open text-lg-end">
              <li className="menu-item-has-children">
                <Link to="/">Home</Link>
              </li>
              <li className="menu-item-has-children">
                <Link to="/service">Service</Link>
              </li>
              <li className="menu-item-has-children">
                <Link to="/about">About Us</Link>
              </li>
              <li className="menu-item-has-children">
                <Link to="/careers">Careers</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div className="nav-right-part nav-right-part-desktop align-self-center">
            <a className="navbar-phone" href="tel:">
              <span className="icon">
                <img src="/assets/img/icon/1.png" alt="img" />
              </span>
              <span>Need help?</span>
              <h5>+91 84332 13907</h5>
            </a>
          </div>
        </div>
      </nav>
      {/* navbar end */}
    </>
  );
};

export default NavBar;
